import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, CanMatch, Route, UrlSegment } from '@angular/router'
import { Observable } from 'rxjs'
import { filter, map, take } from 'rxjs/operators'

import { ClinicService } from '../services/clinic.service'

export type UnifiedEstimatorGuardMode = 'enabled' | 'disabled'

@Injectable({
  providedIn: 'root',
})
export class UnifiedEstimatorGuard implements CanActivate, CanMatch {
  constructor(private clinicService: ClinicService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const mode = this.resolveModeFromData(route.data)
    return this.evaluate(mode)
  }

  canMatch(route: Route, _segments: UrlSegment[]): Observable<boolean> {
    const mode = this.resolveModeFromData(route.data)
    return this.evaluate(mode)
  }

  private evaluate(mode: UnifiedEstimatorGuardMode): Observable<boolean> {
    return this.clinicService.clinic$.pipe(
      filter((clinic): clinic is NonNullable<typeof clinic> => clinic != null),
      take(1),
      map(clinic => {
        const enabled = this.clinicService.isUnifiedEstimatorEnabled(clinic)
        return mode === 'enabled' ? enabled : !enabled
      }),
    )
  }

  private resolveModeFromData(data: Record<string, unknown> | undefined): UnifiedEstimatorGuardMode {
    const candidate = data?.['unifiedEstimatorMode']
    return candidate === 'disabled' ? 'disabled' : 'enabled'
  }
}
